var _a;
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    collectorCurrentCollected: 0,
    collectorLastCollected: 0,
    collectorMinRequired: 1
};
var mazeSlice = createSlice({
    name: 'maze',
    initialState: initialState,
    reducers: {
        resetCollectorCurrentCollected: function (state) {
            state.collectorCurrentCollected = 0;
        },
        setCollectorCurrentCollected: function (state, action) {
            state.collectorCurrentCollected = action.payload;
            state.collectorLastCollected = action.payload;
        },
        setCollectorMinRequired: function (state, action) {
            state.collectorMinRequired = action.payload;
        }
    }
});
export var resetCollectorCurrentCollected = (_a = mazeSlice.actions, _a.resetCollectorCurrentCollected), setCollectorCurrentCollected = _a.setCollectorCurrentCollected, setCollectorMinRequired = _a.setCollectorMinRequired;
export default mazeSlice.reducer;
